import { directorApi } from "../director/directorApi";

// «Оқулықтағы беттер»: /api/books/*. Контракт: BookHit из bff, ключ book-reader в браузер не уходит.

export interface BookHit {
  refId: number | null;
  bookId: string;
  bookTitle: string | null;
  author: string | null;
  subject: string | null;
  grade: number | null;
  lang: string | null;
  pageNumber: number;
  snippet: string | null;
  pdfUrl: string | null;
}

export interface BookHits {
  configured: boolean;
  pinned?: boolean;
  topicTitle?: string | null;
  lang?: string | null;
  subject?: string | null;
  items: BookHit[];
}

export const booksApi = directorApi
  .enhanceEndpoints({ addTagTypes: ["BookRefs"] })
  .injectEndpoints({
    endpoints: (build) => ({
      getTopicBooks: build.query<BookHits, number>({
        query: (courseTopicId) => ({ url: `books/topic/${courseTopicId}` }),
        transformResponse: (r: { data: BookHits }) => r.data,
        providesTags: (_r, _e, id) => [{ type: "BookRefs", id }],
      }),
      getBookSubjects: build.query<string[], void>({
        query: () => ({ url: "books/subjects" }),
        transformResponse: (r: { data: any }) => {
          const list = Array.isArray(r.data) ? r.data : r.data?.subjects || [];
          return Array.from(
            new Set<string>(
              list.map((s: any) =>
                typeof s === "string" ? s : s.subject || s.title || s.name
              )
            )
          );
        },
      }),
      searchBooks: build.query<
        BookHits,
        { q: string; subject: string; lang: string }
      >({
        query: (params) => ({ url: "books/search", params }),
        transformResponse: (r: { data: BookHits }) => r.data,
      }),
      addBookRef: build.mutation<
        unknown,
        { courseTopicId: number; hit: BookHit }
      >({
        query: ({ courseTopicId, hit }) => ({
          url: `books/topic/${courseTopicId}/refs`,
          method: "POST",
          body: hit,
        }),
        invalidatesTags: (_r, _e, a) => [
          { type: "BookRefs", id: a.courseTopicId },
        ],
      }),
      removeBookRef: build.mutation<
        unknown,
        { courseTopicId: number; refId: number }
      >({
        query: ({ refId }) => ({
          url: `books/refs/${refId}`,
          method: "DELETE",
        }),
        invalidatesTags: (_r, _e, a) => [
          { type: "BookRefs", id: a.courseTopicId },
        ],
      }),
    }),
  });
